import { createBrowserRouter, Navigate, useLocation, useParams } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import Home from '@/pages/home/Home'
/* import { Login } from '@/pages/user/Login' */
import { Login } from '@/pages/user/Login/newIndex'
import { UnLogin } from '@/pages/user/UnLogin/unlogin'
import { Register } from '@/pages/user/Register'
import { QuestionList } from '@/pages/home/QuestionList'
import { QuestionDetail } from '@/pages/home/QuestionDetail'
import { SelectRole } from '@/pages/user/SelectRole'
import { AddOrder } from '@/pages/home/AddOrder'
import { My } from '@/pages/user/My'
import { Search } from '@/pages/home/Search'
import { UserAgreement } from '@/pages/user/UserAgreement'
import { PrivacyAgreement } from '@/pages/user/PrivacyAgreement'
import { SelectGame } from '@/pages/user/SelectGame'
import { ShowPage } from '@/pages/home/ShowPage'
import i18n from '@/utils/i18n';
import { ImageShow } from '@/pages/home/ImageShow'

const RedirectComponent = () => {
  const location = useLocation();
  const params = useParams();

  // 从params对象中获取路由参数
  const { id } = params;
  const { search } = location

  const dealSdkParams = () => {
    if (id) {
      let _ = search.indexOf('?') > -1 ? '&' : '?'
      return `${_}sdk=${id}`
    }
    return ''
  }

  // 构建重定向路径，包含路由参数
  const redirectToPath = `/${search}${dealSdkParams()}`;

  // 执行重定向
  return <Navigate to={redirectToPath} replace />;
};

export const router = createBrowserRouter([
  {
    path: '/:gameCode?',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
        handle: { title: `${i18n.t('router.home-title')}` },
      },
      {
        path: 'question-list',
        element: <QuestionList />,
        handle: { title: `${i18n.t('router.question-title')}` },
      },
      {
        path: 'question-detail/:id',
        element: <QuestionDetail />,
        handle: { title: `${i18n.t('router.question-detail-title')}` },
      },
      {
        path: 'login',
        element: <Login />,
        handle: { title: `${i18n.t('router.login-title')}` },
      },
      {
        path: 'unlogin',
        handle: { title: `${i18n.t('router.login-title')}` },
        element: <UnLogin />,
      },
      {
        path: 'register',
        element: <Register />,
        handle: { title: `${i18n.t('router.register-title')}` },
      },
      {
        path: 'select-role',
        element: <SelectRole />,
        handle: { title: `${i18n.t('router.select-role-title')}` },
      },
      {
        path: 'add-order/:classId',
        element: <AddOrder />,
        handle: { title: `${i18n.t('router.add-order-title')}` },
      },
      {
        path: 'my',
        element: <My />,
        handle: { title: `${i18n.t('router.my-title')}` },
      },
      {
        path: 'search',
        element: <Search />,
        handle: { title: `${i18n.t('router.search-title')}` },
      },
      {
        path: 'user-agreement',
        element: <UserAgreement />,
        handle: { title: `${i18n.t('router.user-agreement-title')}` },
      },
      {
        path: 'privacy-agreement',
        element: <PrivacyAgreement />,
        handle: { title: `${i18n.t('router.privacy-policy-title')}` },
      },
      {
        path: 'sdk/:id',
        element: <RedirectComponent />,
      },
      {
        path: 'select-game/:thirdType?',
        handle: { title: `${i18n.t('router.select-game-title')}` },
        element: <SelectGame />,
      },
      {
        path: 'show-status',
        handle: { title: `${i18n.t('router.question-title')}` },
        element: <ShowPage />,
      },
      {
        path: 'image-show',
        handle: { title: `${i18n.t('router.home-title')}` },
        element: <ImageShow />,
      },
    ],
  },

  { path: '*', element: <Navigate to={'/'} /> },
])
